import { EditPage, EditPageTextField, EditPageButton, EditPageSelect, EditPagePanel, EditPageTextArea, EditPageCheckbox } from './../../../common/EditPage';
import { update, getOne } from './../../../common/v4/BackendProvider';
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';


const AiAgentsEdit = () => {
    const [data, setData] = useState({});
    const [metadata, setMetadata] = useState({});
    const [languages, setLanguages] = useState({});
    const navigate = useNavigate();
    const { agent_id } = useParams();
    useEffect(() => {
        getOne('/admin/ai/agents/', agent_id).then(response => {
            setMetadata(response.data.metadata);
            setData(response.data.data);
            // Set initial languages from metadata
            if (response.data.metadata?.languages) {
                setLanguages(response.data.metadata.languages);
            }
        });
    }, []);

    // Load languages when voice is changed
    useEffect(() => {
        if (data.voice_id && data.voice_id !== data.tts_voice?.id) {
            getOne('/admin/ai/agents/voice/', `${data.voice_id}/languages`)
                .then(response => {
                    if (response.data.result === 'OK') {
                        setLanguages(response.data.data.languages);
                    }
                })
                .catch(error => {
                    console.error('Error loading languages:', error);
                });
        }
    }, [data.voice_id]);

    const handleSave = () => {
        update('/admin/ai/agents/', agent_id, {data: data}).then(response => {
            toast.success("AI Agent updated successfully", {});
            navigate('/ai/agents');
        }).catch(error => {
            toast.error("Error updating AI Agent: " + error.message, {});
        });
    }
    const handleCancel = () => {
        navigate('/ai/agents');
    }
    const onChange = (id, value) => {
        // Clear language when voice changes
        if (id === 'voice_id') {
            setData({ ...data, [id]: value, language: undefined });
        } else {
            setData({ ...data, [id]: value });
        }
    }
    return (
        <div>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                closeOnClick={true}
                pauseOnHover={true}
                draggable={true}
                progress="undefined"
            />
            <EditPage handleSave={ handleSave } handleCancel={ handleCancel } title="Edit AI Agent" >
                <EditPagePanel className="col-lg-8">
                    <EditPageTextField label="Name" id="name" onChange={ onChange } value={ data.name } />
                    <EditPageTextField label="Description" id="description" onChange={ onChange } value={ data.description } />
                    <EditPageTextArea label="Backstory" id="backstory" onChange={ onChange } value={ data.backstory } rows={ 80 } />
                    <EditPageCheckbox label="Enabled" id="status" onChange={ onChange } value={ data.status } />
                </EditPagePanel>
                <EditPagePanel className="col-lg-4">
                    <EditPageSelect label="Voice" id="voice_id" onChange={ onChange } value={ data.voice_id } options={ metadata?.voices } />
                    <EditPageSelect label="Language" id="language" onChange={ onChange } value={ data.language } options={ languages } disabled={ !data.voice_id } />
                    <EditPageSelect label="Speech Style" id="speech_style_id" onChange={ onChange } value={ data.speech_style_id } options={ metadata?.speechStyles } />
                </EditPagePanel>
            </EditPage>
        </div>
    );
};

export default AiAgentsEdit;